import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { apiGetPolicyCancelReasonList } from '../../api/policyApi';
import { formatCurrency } from '../../shared/formatters';
export var useCancelPolicyRelatedInfo = function useCancelPolicyRelatedInfo() {
  var _useState = useState([]),
      cancelReasonList = _useState[0],
      setCancelReasonList = _useState[1];

  var _useState2 = useState(false),
      cancelReasonListLoading = _useState2[0],
      setCancelReasonListLoading = _useState2[1];

  var _useState3 = useState([]),
      refundPriceInfoList = _useState3[0],
      setRefundPriceInfoList = _useState3[1];

  var requestPolicyCancelReasonList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$apiGetPolicyCa, _yield$apiGetPolicyCa2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setCancelReasonListLoading(true);
              _context.next = 3;
              return apiGetPolicyCancelReasonList({
                hideErrToast: true
              });

            case 3:
              _yield$apiGetPolicyCa = _context.sent;
              _yield$apiGetPolicyCa2 = _slicedToArray(_yield$apiGetPolicyCa, 1);
              res = _yield$apiGetPolicyCa2[0];
              setCancelReasonListLoading(false);
              setCancelReasonList((res || []).map(function (item) {
                return {
                  value: item.value,
                  label: item.label
                };
              }));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestPolicyCancelReasonList() {
      return _ref.apply(this, arguments);
    };
  }();

  var evaluateCancelRefundPriceInfoList = function evaluateCancelRefundPriceInfoList(data, config) {
    if (data) {
      var _data$adjustmentPrice = data.adjustmentPrice,
          adjustmentPrice = _data$adjustmentPrice === void 0 ? 0 : _data$adjustmentPrice,
          _data$adjustment_pric = data.adjustment_price,
          adjustment_price = _data$adjustment_pric === void 0 ? 0 : _data$adjustment_pric,
          _data$adjustmentAdmin = data.adjustmentAdminFee,
          adjustmentAdminFee = _data$adjustmentAdmin === void 0 ? 0 : _data$adjustmentAdmin,
          _data$adjustmentProce = data.adjustmentProcessingFee,
          adjustmentProcessingFee = _data$adjustmentProce === void 0 ? 0 : _data$adjustmentProce,
          _data$adjustment_proc = data.adjustment_processing_fee,
          adjustment_processing_fee = _data$adjustment_proc === void 0 ? 0 : _data$adjustment_proc,
          _data$adjustmentTax = data.adjustmentTax,
          adjustmentTax = _data$adjustmentTax === void 0 ? 0 : _data$adjustmentTax,
          _data$adjustment_tax = data.adjustment_tax,
          adjustment_tax = _data$adjustment_tax === void 0 ? 0 : _data$adjustment_tax,
          _data$adjustmentTotal = data.adjustmentTotal,
          adjustmentTotal = _data$adjustmentTotal === void 0 ? 0 : _data$adjustmentTotal,
          _data$adjustment_tota = data.adjustment_total,
          adjustment_total = _data$adjustment_tota === void 0 ? 0 : _data$adjustment_tota,
          _data$refundProcessFe = data.refundProcessFee,
          refundProcessFee = _data$refundProcessFe === void 0 ? 0 : _data$refundProcessFe,
          _data$refund_process_ = data.refund_process_fee,
          refund_process_fee = _data$refund_process_ === void 0 ? 0 : _data$refund_process_,
          currency = data.currency;
      var list = [];
      var refundPremiumAmount = Number((config !== null && config !== void 0 && config.useOriginalPriceData ? adjustment_price : adjustmentPrice) || 0);

      if (refundPremiumAmount > 0) {
        list.push({
          title: 'Refund Premium',
          content: formatCurrency({
            amount: refundPremiumAmount,
            currency: currency
          })
        });
      }

      var refundTaxAmount = Number((config !== null && config !== void 0 && config.useOriginalPriceData ? adjustment_tax : adjustmentTax) || 0);

      if (refundTaxAmount > 0) {
        list.push({
          title: 'Refund Tax',
          content: formatCurrency({
            amount: refundTaxAmount,
            currency: currency
          })
        });
      }

      var processingFeeAmount = Number((config !== null && config !== void 0 && config.useOriginalPriceData ? adjustment_processing_fee : adjustmentProcessingFee) || 0);

      if (processingFeeAmount > 0) {
        list.push({
          title: 'Processing fee',
          content: "-".concat(formatCurrency({
            amount: processingFeeAmount,
            currency: currency
          }))
        });
      }

      var cancellationFeeAmount = Number((config !== null && config !== void 0 && config.useOriginalPriceData ? refund_process_fee : refundProcessFee) || 0);

      if (cancellationFeeAmount > 0) {
        list.push({
          title: 'Cancellation fee',
          content: "-".concat(formatCurrency({
            amount: cancellationFeeAmount,
            currency: currency
          }))
        });
      }

      list.push({
        title: 'Refund Amount',
        content: formatCurrency({
          amount: Number((config !== null && config !== void 0 && config.useOriginalPriceData ? adjustment_total : adjustmentTotal) || 0),
          currency: currency
        }),
        bolder: true
      });
      setRefundPriceInfoList(list);
    } else {
      var _ref2 = data || {},
          _currency = _ref2.currency;

      setRefundPriceInfoList([{
        title: 'Refund Amount',
        content: formatCurrency({
          amount: 0,
          currency: _currency
        }),
        bolder: true
      }]);
    }
  };

  return {
    requestPolicyCancelReasonList: requestPolicyCancelReasonList,
    cancelReasonList: cancelReasonList,
    cancelReasonListLoading: cancelReasonListLoading,
    evaluateCancelRefundPriceInfoList: evaluateCancelRefundPriceInfoList,
    refundPriceInfoList: refundPriceInfoList
  };
};